/**
 * Created by Denis Kuzin on 20 october 2021
 */

const AdminPasteClipboardButton = cleverapps.UI.Button.extend({
    ctor: function () {
        const styles = cleverapps.styles.AdminPasteClipboardButton;

        this._super({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(bundles.admin.frames.paste_icon),
            width: styles.width,
            height: styles.height,
            onClicked: this.onPressed.bind(this)
        });

        this.adminLevels = cleverapps.administrator.adminLevels;

        cleverapps.clipboardService.on("changed", this.update.bind(this), this);
        this.update();
    },

    onPressed: function () {
        cleverapps.focusManager.display({
            focus: "PasteLevelFromClipboard",
            action: function (f) {
                cleverapps.clipboardService.paste();
                f();
            }
        });
    },

    update: function () {
        const count = cleverapps.clipboardService.getCountOfCopiedItems();
        if (count > 0) {
            this.enable();
        } else {
            this.disable();
        }
    }
});

cleverapps.styles.AdminPasteClipboardButton = {
    width: 45,
    height: 45
};